import { AlertTriangle, CheckCircle2, XCircle } from 'lucide-react'
import type { ChecklistItem } from '../api/onboarding-types'
import { CHECKLIST_GROUPS } from '../utils/onboarding-meta'

/**
 * The server-side completeness report: errors block submit, warnings go to the
 * reviewers. With `onJump`, open items become buttons that take you to the field.
 */
export function OnboardingChecklist({
  items,
  onJump,
}: {
  items: ChecklistItem[]
  onJump?: (item: ChecklistItem) => void
}) {
  return (
    <div className="flex flex-col gap-4">
      {CHECKLIST_GROUPS.map((g) => {
        const rows = items.filter((i) => i.group === g.key)
        if (!rows.length) return null
        return (
          <div key={g.key} className="flex flex-col gap-1.5">
            <h3 className="text-sm font-semibold text-secondary">{g.label}</h3>
            <ul className="flex flex-col gap-1">
              {rows.map((r) => {
                const icon = r.ok ? (
                  <CheckCircle2 size={16} className="mt-0.5 shrink-0 text-success-text" aria-label="Done" />
                ) : r.severity === 'warning' ? (
                  <AlertTriangle size={16} className="mt-0.5 shrink-0 text-warning-text" aria-label="Warning" />
                ) : (
                  <XCircle size={16} className="mt-0.5 shrink-0 text-danger-text" aria-label="Missing" />
                )
                const text = (
                  <span>
                    <span className={r.ok ? 'text-secondary' : 'text-primary'}>{r.label}</span>
                    {!r.ok && r.message ? <span className="block text-sm text-secondary">{r.message}</span> : null}
                  </span>
                )
                return (
                  <li key={r.key}>
                    {!r.ok && onJump ? (
                      <button type="button" onClick={() => onJump(r)}
                        className="flex w-full items-start gap-2 rounded-md px-1.5 py-1 text-left text-md hover:bg-surface-hover">
                        {icon}
                        {text}
                      </button>
                    ) : (
                      <div className="flex items-start gap-2 px-1.5 py-1 text-md">
                        {icon}
                        {text}
                      </div>
                    )}
                  </li>
                )
              })}
            </ul>
          </div>
        )
      })}
    </div>
  )
}
